import { Injectable } from '@angular/core';
import { SocketService } from '@frontend/common/util';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  GlobalCreateDepartmentSuccessWs,
  GlobalRemoveDepartmentSuccessWs,
  GlobalUpdateDepartmentSuccessWs,
  LocalCreateDepartmentFailureWs,
  LocalCreateDepartmentSuccessWs,
  LocalRemoveDepartmentFailureWs,
  LocalRemoveDepartmentSuccessWs,
  LocalUpdateDepartmentFailureWs,
  LocalUpdateDepartmentSuccessWs,
} from './department-ws.actions';

@Injectable()
export class DepartmentWsEffects {
  LocalCreateDepartmentSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('departments.create')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalCreateDepartmentSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalCreateDepartmentFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('departments.create')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalCreateDepartmentFailureWs({ correlation_id, message })
        )
      )
  );

  LocalUpdateDepartmentSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('departments.update')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalUpdateDepartmentSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalUpdateDepartmentFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('departments.update')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalUpdateDepartmentFailureWs({ correlation_id, message })
        )
      )
  );

  LocalRemoveDepartmentSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('departments.remove')
      .pipe(
        map(
          ({ correlation_id }) => new LocalRemoveDepartmentSuccessWs({ correlation_id })
        )
      )
  );

  LocalRemoveDepartmentFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('departments.remove')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalRemoveDepartmentFailureWs({ correlation_id, message })
        )
      )
  );

  GlobalCreateDepartmentSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('departments.create')
      .pipe(map(() => new GlobalCreateDepartmentSuccessWs()))
  );

  GlobalUpdateDepartmentSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('departments.update')
      .pipe(map(() => new GlobalUpdateDepartmentSuccessWs()))
  );

  GlobalRemoveDepartmentSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('departments.remove')
      .pipe(map(({ id }: any) => new GlobalRemoveDepartmentSuccessWs({ id })))
  );

  constructor(private socketSrv: SocketService) {}
}
